import { FC, Suspense } from 'react'
import { Loader } from 'features/PageLoader/loaderComponent'
import { Navigate, Route, Routes, unstable_HistoryRouter as Router } from 'react-router-dom'

// PAGES
import history from 'shared/helpers/history'
import { LoginPage } from 'pages/Login'
import { Company } from 'pages/Company'
import { Notifications } from 'pages/Notifications'
import { TableReservation } from 'pages/TableReservation'
import { QRCode } from 'pages/QRCode'
import { useAuthStore } from 'shared/store/authSlice'

export const AppRouter: FC = () => {
  //   const { isLoggedIn, isShippingPointSet, hasAccess } = useStore(appStore)
  //   const hasAccess = true

  const { isLoggedIn } = useAuthStore()

  const getRedirectPath = () => {
    switch (true) {
      case isLoggedIn:
        return '/company'
      case !isLoggedIn:
        return '/login'
      default:
        window.location.replace('https://console.hssoft.com/')
        return '/login'
    }
  }

  return (
    <Router history={history}>
      <Suspense fallback={<Loader isLoading />}>
        <Routes>
          <Route
            path='/company'
            element={
              <PrivateRoute isAllowed={isLoggedIn}>
                <Company />
              </PrivateRoute>
            }
          />
          <Route
            path='/qr_code'
            element={
              <PrivateRoute isAllowed={isLoggedIn}>
                <QRCode />
              </PrivateRoute>
            }
          />
          <Route
            path='/table_reservation'
            element={
              <PrivateRoute isAllowed={isLoggedIn}>
                <TableReservation />
              </PrivateRoute>
            }
          />
          <Route
            path='/notifications'
            element={
              <PrivateRoute isAllowed={isLoggedIn}>
                <Notifications />
              </PrivateRoute>
            }
          />
          <Route
            path='/login'
            element={
              <PrivateRoute isAllowed={!isLoggedIn}>
                <LoginPage />
              </PrivateRoute>
            }
          />
          {/* TODO: reenable NoAccess page if needed */}
          {/* <Route
            path="/noAccess"
            element={
              <PrivateRoute isAllowed={isLoggedIn && !hasAccess}>
                <NoAccess />
              </PrivateRoute>
            }
          /> */}
          <Route path='*' element={<Navigate to={getRedirectPath()} replace />} />
        </Routes>
      </Suspense>
    </Router>
  )
}

const PrivateRoute: FC<any> = ({ isAllowed = true, children }) => {
  if (isAllowed) {
    return children
  }

  return <Navigate to='/' />
}
